var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _ellipse, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 393,
    viewBox: "0 0 230 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_839_14410",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 98,
    width: 122,
    height: 235
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.2022 145.384L105.355 144.875L106.079 177.116L110.656 179.432L111.65 217.977L124.465 222.651L121.191 332.001L111.922 332.001L81.1266 332.001L3.64258 98.8093L28.3386 137.016L85.2545 189.714L86.3798 166L89.269 167.63L91.2022 145.384Z",
    fill: "#D7EDB4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_839_14410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2022 145.384L105.355 144.875L106.079 177.116L110.656 179.432L111.65 217.977L124.465 222.651L120.927 339.593L111.65 337.931L81.1266 332.001L3.64258 98.8096L28.3386 137.016L85.2545 189.715L86.3798 166L89.269 167.631L91.2022 145.384Z",
    fill: "#D7EDB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7158 144.921H105.309L106.079 177.116L110.66 179.535L111.633 217.101L124.571 222.629L120.927 339.593L111.65 337.931L112.646 267.445L83.6917 222.651L28.3386 137.016L85.2545 189.715L86.4705 166.141L89.269 167.631L90.7158 144.921Z",
    fill: "#AADBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.65 337.931L112.646 267.445L83.6917 222.651L28.3386 137.016L85.2545 189.715L83.6917 222.651L112.646 267.445L111.633 217.101L124.571 222.629L120.927 339.593L111.65 337.931Z",
    fill: "#AADBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.65 337.931L112.646 267.445L83.6917 222.651L28.3386 137.016L79.513 210.002L81.1695 185.932L85.2545 189.715L84.0074 215.997L112.646 254.196L111.65 216.98L118.058 219.816L114.632 338.465L111.65 337.931Z",
    fill: "#48A7A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.269 167.631L106.079 177.116L106.018 174.448L89.4523 164.812L89.269 167.631Z",
    fill: "#48A7A1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8981 144.921L40.4172 109.889L29.9109 54.0156L43.0438 21.079L52.2368 39.5235L76.1387 -0.000488281L83.7558 10.5392L89.0089 1.31698L108.708 22.8419L110.022 15.411H120.528L149.42 68.5077L104.506 144.921H91.8981Z",
    fill: "#DFECFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.754 10.5392L106.08 39.5235L108.706 22.8419L89.0071 1.31698L83.754 10.5392Z",
    fill: "#7DA7E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.743 144.921H92.135L84.0571 139.424L102.8 141.22L96.3832 128.997L52.4736 39.5235L55.678 34.2247L94.895 119.957L102.237 34.2247L83.9926 10.5392L84.7197 9.26273L102.825 29.4093L104.267 17.6105L108.945 22.8419L107.153 34.2247L106.318 39.5235L96.631 126.765L106.137 142.549L104.743 144.921Z",
    fill: "#7DA7E7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_839_14410",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 220,
    width: 54,
    height: 112
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.688 243.05L122.474 242.808L122.157 258.175L120.147 259.279L119.711 277.651L114.085 279.879L115.522 332L119.592 332L133.111 332L167.127 220.851L156.285 239.062L131.299 264.18L130.805 252.877L129.536 253.654L128.688 243.05Z",
    fill: "#D7EDB4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_839_14410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.688 243.051L122.474 242.808L122.157 258.175L120.147 259.279L119.711 277.651L114.085 279.879L115.638 335.619L119.711 334.827L133.111 332L167.127 220.851L156.285 239.062L131.299 264.18L130.805 252.877L129.536 253.654L128.688 243.051Z",
    fill: "#D7EDB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.901 242.83H122.495L122.157 258.175L120.146 259.328L119.719 277.234L114.039 279.869L115.638 335.619L119.711 334.827L119.274 301.23L131.985 279.879L156.285 239.062L131.299 264.18L130.765 252.944L129.536 253.654L128.901 242.83Z",
    fill: "#AADBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.711 334.827L119.274 301.23L131.985 279.879L156.285 239.062L131.299 264.18L131.985 279.879L119.274 301.23L119.719 277.234L114.039 279.869L115.638 335.619L119.711 334.827Z",
    fill: "#AADBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.711 334.827L119.274 301.23L131.985 279.879L156.285 239.062L133.819 273.85L133.092 262.378L131.299 264.18L131.846 276.708L119.274 294.915L119.711 277.176L116.898 278.528L118.402 335.081L119.711 334.827Z",
    fill: "#48A7A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.536 253.654L122.157 258.175L122.184 256.904L129.456 252.311L129.536 253.654Z",
    fill: "#48A7A1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.383 242.83L150.983 226.132L155.596 199.5L149.83 183.801L145.794 192.593L135.301 173.754L131.958 178.778L129.651 174.382L121.003 184.642L120.427 181.1H115.814L103.13 206.408L122.848 242.83H128.383Z",
    fill: "#DFECFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.957 178.778L122.156 192.593L121.003 184.642L129.651 174.382L131.957 178.778Z",
    fill: "#7DA7E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.741 242.83H128.276L131.822 240.21L123.594 241.065L126.411 235.24L145.688 192.593L144.281 190.067L127.064 230.931L123.841 190.067L131.851 178.778L131.531 178.169L123.583 187.772L122.95 182.148L120.896 184.642L121.683 190.067L122.049 192.593L126.302 234.176L122.129 241.699L122.741 242.83Z",
    fill: "#7DA7E7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_839_14410",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 156,
    width: 92,
    height: 177
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.643 191.568L152.992 191.185L152.448 215.447L149.003 217.19L148.255 246.196L138.612 249.713L141.076 332.001L148.051 332.001L171.225 332.001L229.533 156.52L210.949 185.271L168.119 224.928L167.272 207.082L165.098 208.309L163.643 191.568Z",
    fill: "#D7EDB4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_839_14410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.643 191.568L152.992 191.185L152.448 215.447L149.003 217.19L148.255 246.196L138.612 249.713L141.274 337.714L148.255 336.464L171.225 332.001L229.533 156.52L210.949 185.271L168.119 224.928L167.272 207.082L165.098 208.309L163.643 191.568Z",
    fill: "#D7EDB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.009 191.22H153.027L152.448 215.447L149.001 217.268L148.269 245.537L138.532 249.697L141.274 337.714L148.255 336.464L147.506 283.421L169.295 249.713L210.949 185.271L168.119 224.928L167.204 207.188L165.098 208.309L164.009 191.22Z",
    fill: "#AADBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.255 336.464L147.506 283.421L169.295 249.713L210.949 185.271L168.119 224.928L169.295 249.713L147.506 283.421L148.269 245.537L138.532 249.697L141.274 337.714L148.255 336.464Z",
    fill: "#AADBB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.255 336.464L147.506 283.421L169.295 249.713L210.949 185.271L172.439 240.195L171.193 222.082L168.119 224.928L169.057 244.706L147.506 273.451L148.255 245.446L143.434 247.579L146.012 336.865L148.255 336.464Z",
    fill: "#48A7A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.098 208.309L152.448 215.447L152.494 213.439L164.96 206.188L165.098 208.309Z",
    fill: "#48A7A1"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.12 191.219L201.861 164.858L209.767 122.812L199.884 98.0263L192.966 111.906L174.98 82.1636L169.248 90.0949L165.294 83.155L150.47 99.3529L149.482 93.761H141.576L119.834 133.717L153.633 191.219H163.12Z",
    fill: "#DFECFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.248 90.0949L152.448 111.906L150.471 99.3529L165.295 83.155L169.248 90.0949Z",
    fill: "#7DA7E7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.455 191.219H162.942L169.021 187.083L154.917 188.434L159.745 179.237L192.788 111.906L190.377 107.919L160.865 172.434L155.34 107.919L169.069 90.0949L168.522 89.1343L154.897 104.295L153.812 95.4162L150.292 99.3529L151.641 107.919L152.269 111.906L159.559 177.557L152.406 189.435L153.455 191.219Z",
    fill: "#7DA7E7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.5,
    cy: 368,
    rx: 113.5,
    ry: 25,
    fill: "url(#paint0_radial_839_14410)",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_839_14410",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.5 368) rotate(90) scale(25 113.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AADBAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowers);
export default __webpack_public_path__ + "static/media/Flowers.d5421292a1cb7002b59903b64d2d9e1f.svg";
export { ForwardRef as ReactComponent };